<template>
  <billing-report-panel
    report-key="batches-protocols"
    route="/reports/billing-batches-protocols"
    file-name="protocolos-de-envio.xlsx"
    period-label="Período de envio do lote"
    :columns="columns"
    :status-options="statusOptions"
    show-status
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      statusOptions: ['sent', 'analyzed', 'in_appeal', 'settled'],
      columns: [
        'Lote',
        'Convênio',
        'Enviado em',
        'Protocolo da operadora',
        'Data do protocolo',
        'Situação do protocolo (Tabela 47)',
        'Situação do lote',
        'Valor enviado',
        'Retorno da operadora',
        'Lotes sem protocolo em separado',
      ],
    };
  },
};
</script>
